<div class="pos-relative">
  <div #container
    class="adyen-apple-pay-component"
  id="adyen-apple-pay-container"></div>
  @if (!isCheckoutValid) {
    <button class="fill"
      (click)="validateCheckout()"
    type="button"></button>
  }
</div>
@if (applePayAvailableStatus.error && !validateMerchantStatus.error) {
  <p class="fs-3 col-2"
  >{{applePayAvailableStatus.error}}</p>
}
<result duration="permanent"
[status]="validateMerchantStatus"></result>